export const DATABASE_PHASE_FILTER_OPTIONS = ['P1', 'P2', 'P3', 'P4', 'FP3', 'FP4', 'FP5'] as const;
